"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerCopy = void 0;
const onboardingHeroCopy_1 = require("./onboardingHeroCopy");
exports.registerCopy = {
    header: 'Welcome to the next chapter',
    body: 'Malomo has joined forces with Redo. New accounts start there, with the same great post-purchase tools and even more ahead.',
    cta: 'Get started with Redo →',
    linkPreface: 'Already have an account?',
    linkPrompt: 'Log in.',
    linkHref: '/login',
    heroHeader: onboardingHeroCopy_1.onboardingHeroCopy.header,
    heroSubHeader: onboardingHeroCopy_1.onboardingHeroCopy.subHeader
};
